<template>
  <div id="worker_info">
    <van-nav-bar
      title="证件信息"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      style="margin-bottom: 20px;"
    />
    <van-form>
      <van-field
        v-model="postForm.worker_name"
        name="用户名"
        label="用户名"
        placeholder="用户名"
        @input="changeUserName"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
        v-model="postForm.worker_mobile"
        name="手机号"
        label="手机号"
        placeholder="手机号"
        @input="freshData"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <van-field
        v-model="postForm.id_card_no"
        name="身份证号码"
        label="身份证号码"
        placeholder="身份证号码"
        @input="freshData"
        :rules="[{ required: true, message: '请填写身份证号码' }]"
      />
      <div style="text-align: left;padding-left: 20px;">身份证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <div class="uploader">
              <van-field name="uploader" title="">
                <template #input>
                  <van-uploader v-model="postForm.id_card_front_img"
                                :max-size="maxSize"
                                :before-read="beforeRead"
                                :after-read="file => onRead(file, 'id_card_front')"
                                :before-delete="file => deleteFile(file, 'id_card_front')"
                                :max-count="1"
                                @oversize="onOversize"/>
                </template>
              </van-field>
            </div>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.id_card_back_img"
                              :max-size="maxSize"
                              :before-read="beforeRead"
                              :after-read="file => onRead(file, 'id_card_back')"
                              :before-delete="file => deleteFile(file, 'id_card_back')"
                              :max-count="1"
                              @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">健康码</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.health_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'health')" :before-delete="file => deleteFile(file, 'health')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">行程码</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.travel_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'travel')" :before-delete="file => deleteFile(file, 'travel')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">核酸检测图片</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.nucleic_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'nucleic')" :before-delete="file => deleteFile(file, 'nucleic')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">通行证</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.pass_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'pass')" :before-delete="file => deleteFile(file, 'pass')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">电工证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.ele_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'ele_front')" :before-delete="file => deleteFile(file, 'ele_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.ele_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'ele_back')" :before-delete="file => deleteFile(file, 'ele_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">制冷证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.cold_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'cold_front')" :before-delete="file => deleteFile(file, 'cold_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.cold_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'cold_back')" :before-delete="file => deleteFile(file, 'cold_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">高空证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.high_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'high_front')" :before-delete="file => deleteFile(file, 'high_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.high_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'high_back')" :before-delete="file => deleteFile(file, 'high_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">焊工证</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="text-align: center">正面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.hg_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'hg_front')" :before-delete="file => deleteFile(file, 'hg_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="text-align: center">反面</div>
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.hg_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'hg_back')" :before-delete="file => deleteFile(file, 'hg_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">其他证件</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <div style="float: left; width: 50%">
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.other_front_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'other_front')" :before-delete="file => deleteFile(file, 'other_front')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
        <div style="float: left; width: 50%">
          <div style="margin: 5px auto; width: 60%;">
            <van-field name="uploader" title="">
              <template #input>
                <van-uploader v-model="postForm.other_back_img" :max-size="maxSize" :before-read="beforeRead" :after-read="file => onRead(file, 'other_back')" :before-delete="file => deleteFile(file, 'other_back')" :max-count="1" @oversize="onOversize"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;">保险单</div>
      <div style="overflow: hidden; margin-top: 10px;">
        <van-uploader v-model="postForm.policyList"
                      :max-size="100960 * 1024"
                      multiple
                      :before-read="beforeRead"
                      :after-read="file => onReceiptRead(file)"
                      :before-delete="deleteReceiptFile"
                      @oversize="onOversize"/>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {Toast} from 'vant'
import {getManInfo, updateManInfo} from '@/api/user'
import {
  getOssToken,
  getWorkerInfoReport,
  searchWorkers,
  workerCreateOrUpdateWorkerInfoReport
} from "../../../api/order";
import OSS from "ali-oss";
import {getFileRealPath} from "../../../api/util";
import {createOrUpdateWorkerReport, getWorkerInfoReportNew} from "../../../api/user";

export default {
  name: 'info',
  data () {
    return {
      maxSize: 40960 * 1024,
      workers: [],
      postForm: {
        name: '',
        username: '',
        id_card_no: '',
        ele_front_img: [],
        ele_back_img: [],
        cold_front_img: [],
        cold_back_img: [],
        high_front_img: [],
        high_back_img: [],
        hg_front_img: [],
        hg_back_img: [],
        id_card_back_img: [],
        id_card_front_img: [],
        other_back_img: [],
        other_front_img: [],
        health_img: [],
        img_health_qrcode: '',
        travel_img: [],
        nucleic_img: [],
        pass_img: [],
        policyList: [],
        policy: []
      },
      imageList: [],
      activeNames: ['1'],
      showSelectWorker: false,
      searchData: '',
      checkedValue: [],
    }
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    async onReceiptRead(file) {
      if (file.length > 1) {
        for (const i in file) {
          await this.uploadImg(file[i].file, 'policy')
        }
      } else {
        await this.uploadImg(file.file, 'policy')
      }
    },
    deleteReceiptFile(file, index) {
      console.log('file.........', file, index)
      this.postForm.policy.splice(index, 1)
      return true
    },
    freshData() {
      this.$forceUpdate()
    },
    changeUserName() {
      if (this.postForm.worker_name === '' || typeof this.postForm.worker_name === 'undefined') {
        return true
      }
      searchWorkers({search_str: this.postForm.worker_name}).then(res => {
        if (res.data.data && res.data.data[0] && res.data.data[0].worker_id) {
          this.postForm.worker_uid = res.data.data[0].worker_id
          if (typeof res.data.data[0].worker_name !== 'undefined') {
            this.postForm.worker_name = res.data.data[0].worker_name
          }
          if (typeof res.data.data[0].name !== 'undefined') {
            this.postForm.worker_name = res.data.data[0].name
          }
          this.getWorkerInfo(this.postForm.worker_uid, this.postForm.worker_name)
        } else {
          this.$forceUpdate()
        }
      })
    },
    getWorkerInfo(worker_uid, worker_name = '') {
      console.log('jfdklsafjlksafsadf', worker_name)
      getWorkerInfoReportNew({ appo_task_id: this.$route.query.appo_task_id, worker_uid: worker_uid }).then((result) => {
        if (result.data.data) {
          if (result.data.data.worker_info_report_id) {
            this.postForm.worker_info_report_id = result.data.data.worker_info_report_id
          }
          this.postForm.worker_mobile = result.data.data.worker_mobile
          const data = result.data.data.certificate_list
          this.postForm.id_card_no = data.id_card && data.id_card.id_card_no
          this.postForm.policyList = []
          this.postForm.policy = []
          if (data.policy && data.policy[0]) {
            for (const item in data.policy) {
              if (typeof data.policy[item] !== 'undefined' && data.policy[item]['file_url_thumb']) {
                this.postForm.policyList.push({
                  url: data.policy[item]['file_url_thumb'],
                  status: ''
                })
              }
              this.postForm.policy = this.postForm.policyList
            }
          }
          console.log('idlfjdslkfjdslfjlsdfl', this.postForm.policyList)
          if (data.id_card && data.id_card.img_id_card_front && data.id_card.img_id_card_front.file_url_enough) {
            this.postForm.id_card_front_img = [{
              url: data.id_card && data.id_card.img_id_card_front && data.id_card.img_id_card_front.file_url_enough,
              status: ''
            }]
            this.postForm.img_id_card_front = data.id_card && data.id_card.img_id_card_front && data.id_card.img_id_card_front.file_id
          }
          if (data.id_card && data.id_card.img_id_card_back && data.id_card.img_id_card_back.file_url_enough) {
            this.postForm.id_card_back_img = [{
              url: data.id_card && data.id_card.img_id_card_back && data.id_card.img_id_card_back.file_url_enough,
              status: ''
            }]
            this.postForm.img_id_card_back = data.id_card && data.id_card.img_id_card_back && data.id_card.img_id_card_back.file_id
          }
          if (data.electrician_certificate && data.electrician_certificate.img_front && data.electrician_certificate.img_front.file_url_enough) {
            this.postForm.ele_front_img = [{ url: data.electrician_certificate && data.electrician_certificate.img_front && data.electrician_certificate.img_front.file_url_enough, status: '' }]
          }
          if (data.electrician_certificate && data.electrician_certificate.img_front) {
            this.postForm.ele_front = data.electrician_certificate && data.electrician_certificate.img_front && data.electrician_certificate.img_front.file_id
          }
          if (data.electrician_certificate && data.electrician_certificate.img_back && data.electrician_certificate.img_back.file_url_enough) {
            this.postForm.ele_back_img =  [{ url: data.electrician_certificate && data.electrician_certificate.img_back && data.electrician_certificate.img_back.file_url_enough, status: '' }]
          }
          if (data.electrician_certificate && data.electrician_certificate.img_back && data.electrician_certificate.img_back.file_id) {
            this.postForm.ele_back = data.electrician_certificate && data.electrician_certificate.img_back && data.electrician_certificate.img_back.file_id
          }
          if (data.high_altitude_certificate && data.high_altitude_certificate.img_front && data.high_altitude_certificate.img_front.file_url_enough) {
            this.postForm.high_front_img = [{ url: data.high_altitude_certificate && data.high_altitude_certificate.img_front && data.high_altitude_certificate.img_front.file_url_enough, status: '' }]
          }
          if (data.high_altitude_certificate && data.high_altitude_certificate.img_back && data.high_altitude_certificate.img_back.file_url_enough) {
            this.postForm.high_back_img =  [{ url: data.high_altitude_certificate && data.high_altitude_certificate.img_back && data.high_altitude_certificate.img_back.file_url_enough, status: '' }]
          }
          if (data.high_altitude_certificate && data.high_altitude_certificate.img_front && data.high_altitude_certificate.img_front.file_id) {
            this.postForm.high_front = data.high_altitude_certificate && data.high_altitude_certificate.img_front && data.high_altitude_certificate.img_front.file_id
          }
          if (data.high_altitude_certificate && data.high_altitude_certificate.img_back && data.high_altitude_certificate.img_back.file_id) {
            this.postForm.high_back = data.high_altitude_certificate && data.high_altitude_certificate.img_back && data.high_altitude_certificate.img_back.file_id
          }
          if (data.refrigeration_certificate && data.refrigeration_certificate.img_front && data.refrigeration_certificate.img_front.file_url_enough) {
            this.postForm.cold_front_img = [{ url: data.refrigeration_certificate && data.refrigeration_certificate.img_front && data.refrigeration_certificate.img_front.file_url_enough, status: '' }]
          }
          if (data.refrigeration_certificate && data.refrigeration_certificate.img_front && data.refrigeration_certificate.img_front.file_id) {
            this.postForm.cold_front = data.refrigeration_certificate && data.refrigeration_certificate.img_front && data.refrigeration_certificate.img_front.file_id
          }
          if (data.refrigeration_certificate && data.refrigeration_certificate.img_back && data.refrigeration_certificate.img_back.file_url_enough) {
            this.postForm.cold_back_img = [{ url: data.refrigeration_certificate && data.refrigeration_certificate.img_back && data.refrigeration_certificate.img_back.file_url_enough, status: '' }]
          }
          if (data.refrigeration_certificate && data.refrigeration_certificate.img_back && data.refrigeration_certificate.img_back.file_id) {
            this.postForm.cold_back = data.refrigeration_certificate && data.refrigeration_certificate.img_back && data.refrigeration_certificate.img_back.file_id
          }
          if (data.welder_certificate && data.welder_certificate.img_back && data.welder_certificate.img_back.file_id) {
            this.postForm.hg_front_img = [{ url: data.welder_certificate && data.welder_certificate.img_front && data.welder_certificate.img_front.file_url_enough, status: '' }]
          }
          if (data.welder_certificate && data.welder_certificate.img_front && data.welder_certificate.img_front.file_id) {
            this.postForm.hg_front = data.welder_certificate && data.welder_certificate.img_front && data.welder_certificate.img_front.file_id
          }
          if (data.welder_certificate && data.welder_certificate.img_back && data.welder_certificate.img_back.file_id) {
            this.postForm.hg_back = data.welder_certificate && data.welder_certificate.img_back && data.welder_certificate.img_back.file_id
          }
          if (data.welder_certificate && data.welder_certificate.img_back && data.welder_certificate.img_back.file_url_enough) {
            this.postForm.hg_back_img = [{ url: data.welder_certificate && data.welder_certificate.img_back && data.welder_certificate.img_back.file_url_enough, status: '' }]
          }
          if (data.pass && data.pass.pass_card) {
            this.postForm.pass_card = data.pass && data.pass && data.pass.pass_card && data.pass.pass_card.file_id
            this.postForm.pass_img =  [{ url: data.pass && data.pass.pass_card && data.pass.pass_card.file_url_enough, status: '' }]
          }
          this.postForm.health_img = [{
            url: data.health_report && data.health_report.img_health_qrcode && data.health_report.img_health_qrcode.file_url_enough,
            status: ''
          }]
          this.postForm.img_health_qrcode = data.health_report && data.health_report.img_health_qrcode && data.health_report.img_health_qrcode.file_id
          if (data.health_report && data.health_report.img_nucleic_acid_report) {
            this.postForm.img_nucleic_acid_report = data.health_report && data.health_report.img_nucleic_acid_report && data.health_report.img_nucleic_acid_report.file_id
            this.postForm.nucleic_img = [{
              url: data.health_report && data.health_report.img_nucleic_acid_report && data.health_report.img_nucleic_acid_report.file_url_enough,
              status: ''
            }]
          }
          if (data.health_report && data.health_report.img_travel_qrcode && data.health_report.img_travel_qrcode.file_url_enough) {
            this.postForm.travel_img = [{
              url: data.health_report && data.health_report.img_travel_qrcode && data.health_report.img_travel_qrcode.file_url_enough,
              status: ''
            }]
          }
          if (data.health_report && data.health_report.img_travel_qrcode && data.health_report.img_travel_qrcode.file_id) {
            this.postForm.img_travel_qrcode = data.health_report && data.health_report.img_travel_qrcode && data.health_report.img_travel_qrcode.file_id
          }
          if (data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_back) {
            this.postForm.other_back_img = [{
              url: data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_back && data.other_list.other_list[0].img_back.file_url_enough,
              status: ''
            }]
          }
          if (data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_back) {
            this.postForm.other_back = data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_back && data.other_list.other_list[0].img_back.file_id
          }
          if (data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_front) {
            this.postForm.other_front_img = [{ url: data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_front && data.other_list.other_list[0].img_front.file_url_enough, status: '' }]
          }
          if (data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_front) {
            this.postForm.other_front = data.other_list && data.other_list.other_list[0] && data.other_list.other_list[0].img_front && data.other_list.other_list[0].img_front.file_id
          }
          this.$forceUpdate()
          console.log('postForm......', this.postForm)
        }
      })
    },
    submitSelectedUser() {

    },
    deleteWorker (index) {
      this.postForm.selectedWorkers.splice(index, 1)
    },
    showWorker() {
      this.showSelectWorker = true
      this.searchData = ''
    },
    getUserList() {
      if (this.searchData !== '' && typeof this.searchData !== 'undefined') {
        searchWorkers({search_str: this.searchData}).then(res => {
          this.workers = res.data.data
        })
      }
    },
    async initUserInfo() {
      if (this.$route.query.worker_uid) {
        this.getWorkerInfo(this.$route.query.worker_uid)
      }
      if (this.$route.query.worker_name) {
        this.postForm.worker_name = this.$route.query.worker_name
      }
      if (this.$route.query.worker_mobile) {
        this.postForm.worker_mobile = this.$route.query.worker_mobile
      }
    },
    onOversize() {

    },
    onClickLeft() {
      this.$router.go(-1)
    },
    change() {

    },
    beforeRead (file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    deleteFile(file, index) {
      if (index === 'ele_front') {
        this.postForm.ele_front = ''
        this.postForm.ele_front_img = []
      }
      if (index === 'ele_back') {
        this.postForm.ele_back = ''
        this.postForm.ele_back_img = []
      }
      if (index === 'cold_front') {
        this.postForm.cold_front = ''
        this.postForm.cold_front_img = []
      }
      if (index === 'cold_back') {
        this.postForm.cold_back = ''
        this.postForm.cold_back_img = []
      }
      if (index === 'high_front') {
        this.postForm.high_front = ''
        this.postForm.high_front_img = []
      }
      if (index === 'high_back') {
        this.postForm.high_back = ''
        this.postForm.high_back_img = []
      }
      if (index === 'hg_front') {
        this.postForm.hg_front = ''
        this.postForm.hg_front_img = []
      }
      if (index === 'hg_back') {
        this.postForm.hg_back = ''
        this.postForm.hg_back_img = []
      }
      if (index === 'health') {
        this.postForm.img_health_qrcode = ''
        this.postForm.health_img = []
      }
      if (index === 'travel') {
        this.postForm.img_travel_qrcode = ''
        this.postForm.travel_img = []
      }
      if (index === 'nucleic') {
        this.postForm.img_nucleic_acid_report = ''
        this.postForm.nucleic_img = []
      }
      if (index === 'id_card_front') {
        this.postForm.img_id_card_front = ''
        this.postForm.id_card_front_img = []
      }
      if (index === 'id_card_back') {
        this.postForm.img_id_card_back = ''
        this.postForm.id_card_back_img = []
      }
      if (index === 'other_front') {
        this.postForm.other_front = ''
        this.postForm.other_front_img = []
      }
      if (index === 'other_back') {
        this.postForm.other_back = ''
        this.postForm.other_back_img = []
      }
      if (index === 'pass') {
        this.postForm.pass_card = ''
        this.postForm.pass_img = []
      }
    },
    onRead(file, index) {
      this.uploadImg(file.file, index)
    },
    async uploadImg(file, index) {
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      await getOssToken({file_suffix: fileSuffix}).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              getFileRealPath({file_id: ossData.file_id}).then((res) => {
                if (res.data.data && res.data.data.file_url_original) {
                  const filePath = [
                    {
                      url: res.data.data.file_url_original,
                      status: '',
                      id: ossData.file_id,
                      name: ossData.file_name
                    }
                  ]
                  if (index === 'ele_front') {
                    this.postForm.ele_front = ossData.file_id
                    this.postForm.ele_front_img = filePath
                  }
                  if (index === 'ele_back') {
                    this.postForm.ele_back = ossData.file_id
                    this.postForm.ele_back_img = filePath
                  }
                  if (index === 'cold_front') {
                    this.postForm.cold_front = ossData.file_id
                    this.postForm.cold_front_img = filePath
                  }
                  if (index === 'cold_back') {
                    this.postForm.cold_back = ossData.file_id
                    this.postForm.cold_back_img = filePath
                  }
                  if (index === 'high_front') {
                    this.postForm.high_front = ossData.file_id
                    this.postForm.high_front_img = filePath
                  }
                  if (index === 'high_back') {
                    this.postForm.high_back = ossData.file_id
                    this.postForm.high_back_img = filePath
                  }
                  if (index === 'hg_front') {
                    this.postForm.hg_front = ossData.file_id
                    this.postForm.hg_front_img = filePath
                  }
                  if (index === 'hg_back') {
                    this.postForm.hg_back = ossData.file_id
                    this.postForm.hg_back_img = filePath
                  }
                  if (index === 'id_card_front') {
                    this.postForm.img_id_card_front = ossData.file_id
                    this.postForm.id_card_front_img = filePath
                  }
                  if (index === 'id_card_back') {
                    this.postForm.img_id_card_back = ossData.file_id
                    this.postForm.id_card_back_img = filePath
                  }
                  if (index === 'other_front') {
                    this.postForm.other_front = ossData.file_id
                    this.postForm.other_front_img = filePath
                  }
                  if (index === 'other_back') {
                    this.postForm.other_back = ossData.file_id
                    this.postForm.other_back_img = filePath
                  }
                  if (index === 'health') {
                    this.postForm.img_health_qrcode = ossData.file_id
                    this.postForm.health_img = filePath
                  }
                  if (index === 'travel') {
                    this.postForm.img_travel_qrcode = ossData.file_id
                    this.postForm.travel_img = filePath
                  }
                  if (index === 'nucleic') {
                    this.postForm.img_nucleic_acid_report = ossData.file_id
                    this.postForm.nucleic_img = filePath
                  }
                  if (index === 'pass') {
                    this.postForm.pass_card = ossData.file_id
                    this.postForm.pass_img = filePath
                  }
                  if (index === 'policy') {
                    this.postForm.policy.push({url: filePath, id: ossData.file_id})
                  }
                  console.log('jflskadfjklasflkdsalfds', this.postForm)
                  this.$forceUpdate()
                }
              })

            }
          })
        }
      })
    },
    async onSubmit() {
      if (this.postForm.worker_name === '' || typeof this.postForm.worker_name === 'undefined') {
        Toast('姓名不能为空');
        return false;
      }
      if (this.postForm.worker_mobile === '' || typeof this.postForm.worker_mobile === 'undefined') {
        Toast('手机号不能为空')
        return false
      }
      if (this.postForm.id_card_no.length < 15 || this.postForm.id_card_no.length > 18) {
        Toast('身份证格式错误')
        return false
      }
      const worker_certificate_info = {}
      worker_certificate_info.id_card = {
        id_card_no: this.postForm.id_card_no,
        img_id_card_front: this.postForm.img_id_card_front,
        img_id_card_back: this.postForm.img_id_card_back
      }
      worker_certificate_info.health_report = {
        img_health_qrcode: this.postForm.img_health_qrcode,
        img_travel_qrcode: this.postForm.img_travel_qrcode,
        img_nucleic_acid_report: this.postForm.img_nucleic_acid_report
      }
      if (typeof this.postForm.pass_card === 'undefined') {
        worker_certificate_info.pass = {
          pass_card: this.postForm.pass_card
        }
      }
      worker_certificate_info.electrician_certificate = {
        img_front: this.postForm.ele_front,
        img_back: this.postForm.ele_back
      }
      worker_certificate_info.refrigeration_certificate = {
        img_front: this.postForm.cold_front,
        img_back: this.postForm.cold_back
      }
      worker_certificate_info.high_altitude_certificate = {
        img_front: this.postForm.high_front,
        img_back: this.postForm.high_back
      }
      worker_certificate_info.welder_certificate = {
        img_front: this.postForm.hg_front,
        img_back: this.postForm.hg_back
      }
      worker_certificate_info.other_list = [{
        img_front: this.postForm.other_front,
        img_back: this.postForm.other_back
      }]

      if (this.postForm.policy.length > 0) {
        worker_certificate_info.policy = []
        for (const item in this.postForm.policy) {
          worker_certificate_info.policy.push(this.postForm.policy[item].id)
        }
      }
      const reportData = {
        appo_task_id: this.$route.query.appo_task_id,
        worker_uid: this.postForm.worker_uid,
        worker_certificate_info: worker_certificate_info,
        worker_name: this.postForm.worker_name,
        worker_mobile: this.postForm.worker_mobile
      }
      if (this.$route.query.worker_info_report_id) {
        reportData.worker_info_report_id = this.$route.query.worker_info_report_id
      }
      if (this.postForm.worker_info_report_id) {
        reportData.worker_info_report_id = this.postForm.worker_info_report_id
      }

      console.log('report_data............', reportData)
      createOrUpdateWorkerReport(reportData).then((res) => {
        if (res.data.code === 0) {
          setTimeout(() => {
            Toast('提交成功')
            this.$router.go(-1)
          }, 2000)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/order/components/create-worker.vue